// @ts-nocheck
// 该文件由 kmi 自动生成
// DO NOT CHANGE IT MANUALLY!
import type Radar from '@ks-radar/radar';
import type { RadarOptions } from '@ks-radar/radar';

import type {SpaFmpSDK as SpaFmpSDKType} from '@ks/radar-spa-fmp-sdk';
import type {ResourceCollect as ResourceCollectType } from '@ks-radar/radar-resource-collect';


import Core from '@ks-radar/radar-core';
import NavigationCollect from '@ks-radar/radar-navigation-collect';
import ApiCollect from '@ks-radar/radar-api-collect';
import ErrorCollect from '@ks-radar/radar-error-collect';
import ResourceCollect from '@ks-radar/radar-resource-collect';
import EventCollect from '@ks-radar/radar-event-collect';

import { ApplyPluginsType } from '@kmi/kmijs';
import { getPluginManager } from '@@/core/plugin';


export interface ActionStartDimension {
  name: string;
  extra_info?: object;
}
export interface ActionEndDimension {
  name: string;
  extra_info?: object;
  result_type?: string;
}

interface ActionEndResultDimension {
  name: string;
  msg: msg, // 成功或者失败原因等，看板曲线聚合维度
  extra_info? : object//【可选】需要是对象
}

export interface AdRadar extends Radar {
  action: {
    start: (dimension: ActionStartDimension) => void;
    end: (dimension: ActionEndDimension) => void;
    endSuccess: (dimension: ActionEndResultDimension) => void;
    endFail: (dimension: ActionEndResultDimension) => void;
  }
  spaFMPCollector: SpaFmpSDKType
  resourceHook: ResourceCollectType.resourceHook
}


let radar: AdRadar;


export type { RadarOptions };
  
export function createRadar(){
  if (radar) return radar;

  const monitorConfig = getPluginManager().applyPlugins({
    key: 'monitorConfig',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });

  const {
    getApiCodeAndMsg,
    ...restRadarConfig
  } = monitorConfig?.radar || {};
  
    
  class AdEventCollect extends EventCollect {
    action = {
      ...this.action,
      endSuccess: function(dimension) {
        dimension.extra_info ? 
          dimension.extra_info.msg = dimension.msg : 
          dimension.extra_info = { msg }
        
        return this.end({
          name: dimension.name,
          result_type: '1',
          extra_info: dimension.extra_info
        });
      },
      endFail: function(dimension) {
        dimension.extra_info ? 
          dimension.extra_info.msg = dimension.msg : 
          dimension.extra_info = { msg }
        
        return this.end({
          name: dimension.name,
          result_type: '0',
          extra_info: dimension.extra_info
        });
      },
    } as {
        start: (dimension: ActionStartDimension) => void;
        end: (dimension: ActionEndDimension) => void;
        endSuccess: (dimension: ActionEndResultDimension) => void;
        endFail: (dimension: ActionEndResultDimension) => void;
    }
  }
  
  
    const core = new Core({
      projectId: '1c3b87363f',
      customDimensions: {
        release_tag: window.kfxEnv && window.kfxEnv.channelId,
        product_version: window.kfxEnv && window.kfxEnv.version,
        
      },
      ...restRadarConfig,
    });
    const navigationCollect = new NavigationCollect({ core });
const apiCollect = new ApiCollect({ 
              core,
              APIHook({ response, request }) {
                if (response.status < 200 || response.status > 399) {
                  return ;
                }
                
                if (request.method === 'GET' && request.url.includes('.json')) { // firefly 特殊处理
                  return {
                    response_code: 521026, // firefly 专用 code，写死521026即可，不需要关注。
                    response_msg: 'firefly 获取成功', 
                    custom_failed: false
                  };
                }
                let response_code, response_msg;
                try {
                  if (typeof getApiCodeAndMsg === 'function') {
                    const obj = getApiCodeAndMsg({response, request}) || {};
                    response_code = obj.response_code;
                    response_msg = obj.response_msg;
                  }
                } catch (err) {
                  // 不做处理
                }
          
                if(response_code) {
                  return {
                    response_code,
                    response_msg,
                    custom_failed: response_code == 1 ? false : true
                  };
                }
          
                const data = response && response.data 
                  ? typeof response.data === 'string' 
                    ? JSON.parse(response.data) 
                    : response.data
                  : null
                if (Object.prototype.toString.call(data) === '[object Object]') {
                  const code = data.status || data.result || data.code || 521025;
                  return {
                    response_code: code,
                    response_msg: data.error_msg || data.msg || data.errorMsg || data.message || data,
                    custom_failed: code == 1 ? false : true
                  };
                }
          
                return {
                  response_code: 521024, // 自定义特殊 code，写死521024即可，不需要关注。
                  response_msg: data, // 特殊场景统计
                  custom_failed: true
                };
              },
            });
const errorCollect = new ErrorCollect({ core });
const resCollect = new ResourceCollect({ 
              core,
              resourceHook: restRadarConfig.resourceHook
             });
const eventCollect = new AdEventCollect({ core });

    
      core.action = eventCollect.action;
      core.event = eventCollect.event.bind(eventCollect);
    

    


      core.fmp = navigationCollect.fmp.bind(navigationCollect);
      core.captureException = errorCollect.captureException.bind(errorCollect);
      
    radar = core;
    
  
}
  
export {
  radar
}